export default "__VITE_ASSET__CaXs4x13__"